import { IConfigService }                  from '@cs/performance-manager/shared';

export abstract class IframeDocumentationConfigService implements IConfigService {

	moduleName = 'docs';

}
